import { initReactI18next } from 'react-i18next';

import stringres from 'i18next';

import common_en from './en.json';
import common_fr from './fr.json';
import common_it from './it.json';

export function str(key: string) {
    return stringres.t(key);
}

const resources = {
    it: { translation: common_it },
    en: { translation: common_en },
    fr: { translation: common_fr },
};

stringres.use(initReactI18next).init({
    resources,
    lng: 'en',
    keySeparator: false,
    interpolation: { escapeValue: false },
});

export default stringres;
